import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-plus/es/components/message/style/css'
import 'element-plus/es/components/message-box/style/css'
import { Plus, CirclePlus, Warning, DArrowLeft, Search, RefreshRight, Download, Upload, Delete } from '@element-plus/icons-vue'
import { Field, Cascader, Popup } from 'vant'
import directive from '@/utils/directive.js'

import 'vant/lib/index.css'
import '@/assets/styles/index.scss'


const app = createApp(App)

app.component('IconPlus', Plus)
app.component('CirclePlus', CirclePlus)
app.component('Warning', Warning)
app.component('DArrowLeft', DArrowLeft)
app.component('IconSearch', Search)
app.component('RefreshRight', RefreshRight)
app.component('IconDownload', Download)
app.component('IconDelete', Delete)
app.component('IconUpload', Upload)
app.use(Field)
app.use(Cascader)
app.use(Popup)

directive(app)

app.use(store).use(router).mount('#app')
